import { Box, Button, Stack, Typography } from "@mui/material";
import EnhancedTable from "../../../../components/shared/table";

/** Standard action icon size — matches UM/Yeksa/userinfo tables. */
export const TABLE_ACTION_ICON_SX = { width: "1rem", height: "1rem" };

/**
 * Standard data table for Market Growth admin pages.
 * Wraps shared EnhancedTable (sort, search, pagination, styled header/rows).
 */
const MarketGrowthDataTable = ({
  rowKey = "id",
  rows = [],
  headCells = [],
  actions,
  pageSize = 10,
  loading = false,
  showPaging = true,
  showFilter = true,
  showIndex = true,
  defaultSort = null,
  tableMinWidth = 750,
  actionsMode = "inline",
  isDashboard = false,
}) => (
  <EnhancedTable
    rowKey={rowKey}
    rows={rows}
    headCells={headCells}
    actions={actions}
    pageSize={pageSize}
    loading={loading}
    showPaging={showPaging}
    showFilter={showFilter}
    showIndex={showIndex}
    defaultSort={defaultSort}
    tableMinWidth={tableMinWidth}
    actionsMode={actionsMode}
    isDashboard={isDashboard}
  />
);

export const MarketGrowthServerPagination = ({
  page,
  totalPages,
  totalCount,
  pageSize,
  onPageChange,
}) => {
  if (!totalCount || totalCount <= pageSize) return null;

  return (
    <Box display="flex" justifyContent="space-between" alignItems="center" sx={{ mt: 2 }}>
      <Typography variant="body2" color="text.secondary">
        {totalCount} رکورد — صفحه {page} از {totalPages}
      </Typography>
      <Stack direction="row" spacing={1}>
        <Button disabled={page <= 1} onClick={() => onPageChange(page - 1)}>
          قبلی
        </Button>
        <Button disabled={page >= totalPages} onClick={() => onPageChange(page + 1)}>
          بعدی
        </Button>
      </Stack>
    </Box>
  );
};

export default MarketGrowthDataTable;
